import '../css/main.css'

const version = process.env.BUILD_TIME;

function ready(fn) {
    if (document.readyState != 'loading'){
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

ready(() => {
    setTimeout(() => {
        document.querySelectorAll('header .characters-container > *').forEach(element => {
            element.classList.add('in')
        })
        setTimeout(() => {
            document.querySelector('header .text').classList.add('in')
        }, 500)
    }, 500)
})
